import { createSlice } from "@reduxjs/toolkit";

const savedLang = localStorage.getItem("language") || "en";

const languageSlice = createSlice({
  name: "language",
  initialState: {
    language: savedLang,
    langParam: savedLang === "pr" ? 2 : 1,
  },
  reducers: {
    setLanguage: (state, action) => {
      const lang = action.payload;
      state.language = lang;
      state.langParam = lang === "pr" ? 2 : 1;
      localStorage.setItem("language", lang);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export const selectLanguage = (state) => state.languageData.language;
export const selectLangParam = (state) => state.languageData.langParam;
export default languageSlice.reducer;
